
import { GroupLeaderRequest } from "@/types/admin-requests";
import { PendingActions } from "./PendingActions";
import { DeleteAction } from "./DeleteAction";
import { SendInvitationAction } from "./SendInvitationAction";
import { ResetPasswordAction } from "./ResetPasswordAction";

interface RequestActionsProps {
  request: GroupLeaderRequest;
  processingId: string | null;
  onApprove: (request: GroupLeaderRequest) => Promise<void>;
  onReject: (request: GroupLeaderRequest) => Promise<void>;
  onDelete: (request: GroupLeaderRequest) => Promise<void>;
  onSendInvitation?: (request: GroupLeaderRequest) => Promise<void>;
  onResetPassword?: (request: GroupLeaderRequest) => Promise<void>;
}

export const RequestActions = ({
  request,
  processingId,
  onApprove,
  onReject,
  onDelete,
  onSendInvitation,
  onResetPassword,
}: RequestActionsProps) => {
  // Log for debugging
  console.log('RequestActions for request:', request.id, {
    status: request.status,
    email_sent: request.email_sent,
    shouldShowSendButton: request.status === 'approved' && request.email_sent === false,
    hasHandler: !!onSendInvitation
  });

  if (request.status === 'pending') {
    return (
      <PendingActions
        request={request}
        processingId={processingId}
        onApprove={onApprove}
        onReject={onReject}
      />
    );
  }

  // For approved requests that don't have an email sent yet, show the send invitation button
  if (request.status === 'approved' && request.email_sent === false && onSendInvitation) {
    console.log('Rendering SendInvitationAction for request:', request.id);
    return (
      <div className="flex justify-end gap-2">
        <SendInvitationAction
          request={request}
          processingId={processingId}
          onSendInvitation={onSendInvitation}
        />
        {onResetPassword && (
          <ResetPasswordAction
            request={request}
            processingId={processingId}
            onResetPassword={onResetPassword}
          />
        )}
        <DeleteAction
          request={request}
          processingId={processingId}
          onDelete={onDelete}
        />
      </div>
    );
  }

  return (
    <div className="flex justify-end gap-2">
      {request.status === 'approved' && onResetPassword && (
        <ResetPasswordAction
          request={request}
          processingId={processingId}
          onResetPassword={onResetPassword}
        />
      )}
      <DeleteAction
        request={request}
        processingId={processingId}
        onDelete={onDelete}
      />
    </div>
  );
};
